import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import CustomTooltip from '../ToolTip/CustomTooltip';
import { defaultSizes } from './constants';
import { BaseLibraryItem } from './types';

const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${defaultSizes.cardWidth};
    height: ${defaultSizes.cardHeight};
    background: transparent;
    margin-top: 0;
    position: relative;
`;

const VideoDetails = styled.div`
    margin-top: 0.5rem;
`;

const Title = styled(Typography)`
    color: ${({ theme }) => theme.colors.black.main};
    padding-right: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const DateField = styled.div`
    font-weight: 400;
    font-size: 1.2rem;
    color: #7e7e7e;
    white-space: nowrap;
`;

const ItemBadge = styled.div`
    color: ${({ theme }) => theme.colors.primary.main};
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.primary.bg};
    border-radius: 4px;
    width: fit-content;
    height: 21px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
`;

const BottomDetails = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

interface Props {
    item: BaseLibraryItem;
    showBadge?: boolean;
    className?: string;
    badgeContent?: ReactNode;
    children: ReactNode;
    onClick?: () => void;
}

const dateFormatOptions: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

function LibraryItemCard({ children, item, className, badgeContent, showBadge, onClick }: Props) {
    const itemName = item.name;

    return (
        <ItemContainer onClick={onClick} className={className}>
            {children}
            <VideoDetails>
                <CustomTooltip title={itemName} containerWidth="100%" placement="top">
                    <Title variant="h5">{itemName}</Title>
                </CustomTooltip>
                <BottomDetails>
                    <DateField>{new Date(item.created_at).toLocaleDateString('en-US', dateFormatOptions)}</DateField>
                    {showBadge && <ItemBadge>{badgeContent}</ItemBadge>}
                </BottomDetails>
            </VideoDetails>
        </ItemContainer>
    );
}

export default LibraryItemCard;
